<template>
  <i :class="iconClass"></i>
</template>
<script>
export default {
  name: "icon",
  props: {
    type: {
      type: String,
      required: true,
    },
    lib: {
      type: String,
      default: "fas",
    },
  },
  computed: {
    iconClass: function () {
      return `${this.lib} fa-${this.type} fa-fw`;
    },
  },
};
</script>
